<template>
  <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" append-to-body :modal="false">
    <el-alert :title="`请选择${label}`" class="mb10" type="success"></el-alert>
    <span class="title label">{{label}}：</span>
    <el-select v-model="selectValue" class="content" filterable size="mini">
      <el-option v-for="item in option" :key="item" :label="item" :value="item"></el-option>
    </el-select>
    <p v-if="couldAdd">没有找到想要的职能模块？点击<span class="add-btn" @click="toAddCategory">新增</span>添加职能模块</p>
    <span slot="footer" class="dialog-footer">
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="onCancel">取 消</div>
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="onConfirm">确 定</div>
    </span>
    <!-- 添加职能模块 -->
    <addCategory ref="addCategory" @addCategory="addCategory"></addCategory>
  </el-dialog>
</template>
<script>
import addCategory from './addCategory'

export default {
  components: { addCategory },
  props: {
    couldAdd: { type: Boolean, default: true },
  },
  data() {
    return {
      dialogVisible: false,
      label: '',
      option: [],
      selectValue: '',
    }
  },
  methods: {
    toAddCategory() {
      this.$refs.addCategory.open()
    },
    addCategory(data) {
      this.$emit('addCategory', data)
      this.dialogVisible = false
    },
    open({ label, option }) {
      this.label = label
      this.option = option
      this.selectValue = ''
      this.dialogVisible = true
    },
    onCancel() {
      this.dialogVisible = false
    },
    onConfirm() {
      if (!this.selectValue) return this.$message.error('你还没有选择选项')
      this.$emit('choose', this.selectValue)
      this.dialogVisible = false
    },
  },
}
</script>
<style scoped>
.add-btn {
  color: rgb(231, 31, 31);
  cursor: pointer;
}
</style>
